import EvaluacionCognitiva from "../../../components/EvaluacionCognitiva/evaluacionCognitiva";
import React from "react";

const CogniEvaManage = () => {
    return (
        <div className="inventory-management">
            <EvaluacionCognitiva />
        </div>
    );
};

export default CogniEvaManage;
